// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--1prNB","bodyText":"styles-module--bodyText--2XcTA"};